<template>
  <div class="tools-page">
    <section class="tools-page__intro">
      <div class="tools-page__hero-content">
        <h1>{{ $t("tools-page__hero-contente") }}</h1>
      </div>
    </section>

    <section class="tools-page__main">
      <div class="tools-page__content-wrapper">
        <h2 class="tools-page__main-title">
          {{ $t("tools-page__main-title") }}
        </h2>
        <div class="tools-page__pae-content">
          <div class="tools-page__two-columns">
            <div class="tools-page__column">
              <p>{{ $t("tools-page__column-left") }}</p>
            </div>
            <div class="tools-page__column">
              <p>{{ $t("tools-page__column-right") }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="tools-page__ref">
      <div class="tools-page__ref-content">
        <div class="tools-page__ref-left">
          <h2>{{ $t("tools-page__ref-left-title") }}</h2>
          <p>{{ $t("tools-page__ref-left-description") }}</p>
        </div>
        <div class="tools-page__ref-right">
          <h2>{{ $t("tools-page__ref-right-title1") }}</h2>
          <p>{{ $t("tools-page__ref-right-description1") }}</p>
          <h2>{{ $t("tools-page__ref-right-title2") }}</h2>
          <p>{{ $t("tools-page__ref-right-description2") }}</p>
        </div>
      </div>
    </section>

  
    <section class="tools-page__explore">
      <h2 class="tools-page__explore-title">
        {{ $t("tools-page__explore-title") }}
      </h2>
      <div class="tools-page__menu-wrapper">
        <div class="tools-page__menu-item">
          <a href="#" @click.prevent="searchAndNavigate('A')">
            <img
              :src="landmarkIcon"
              alt="Landmark Icon"
            />
            <span>{{ $t("tools-page__menu-itemA") }}</span>
          </a>
        </div>
        <div class="tools-page__menu-item">
          <a href="#" @click.prevent="searchAndNavigate('B')">
            <img
              :src="handshakeIcon"
              alt="Handshake Icon"
            />
            <span>{{ $t("tools-page__menu-itemB") }}</span>
          </a>
        </div>
        <div class="tools-page__menu-item">
          <a href="#" @click.prevent="searchAndNavigate('C')">
            <img
              :src="gearsIcon"
              alt="Gears Icon"
            />
            <span>{{ $t("tools-page__menu-itemC") }}</span>
          </a>
        </div>
        <div class="tools-page__menu-item">
          <a href="#" @click.prevent="searchAndNavigate('D')">
            <img
              :src="sackDollarIcon"
              alt="Sack Dollar Icon"
            />
            <span>{{ $t("tools-page__menu-itemD") }}</span>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useToolsPage } from "./script";

export default {
  name: "ToolsPage",
  setup() {
    const {
      searchAndNavigate,
      landmarkIcon,
      handshakeIcon,
      gearsIcon,
      sackDollarIcon,
    } = useToolsPage();

    return {
      searchAndNavigate,
      landmarkIcon,
      handshakeIcon,
      gearsIcon,
      sackDollarIcon,
    };
  },
};
</script>


<style scoped src="./style.css"></style>